module.exports = __webpack_public_path__ + "media/images/icons/undo-1b26d6cd0571ec0d6e32fcfbdc6f5898.svg";